function wrapText(ctx, text, maxWidth) {
    return text.split(/\s+/).filter(Boolean).reduce((lines, word) => {
        const testLine = lines.length ? `${lines[lines.length - 1]} ${word}` : word
        if (ctx.measureText(testLine).width > maxWidth && lines.length) lines.push(word)
        else if (lines.length) lines[lines.length - 1] = testLine
        else lines.push(testLine)
        return lines
    }, [])
}

function drawWrappedText(ctx, text, x, y, w, h, { baseSize, minSize = 8, lineHeightRatio = 1.25 }) {
    ctx.save()
    ctx.direction = 'rtl'
    ctx.textAlign = 'right'
    ctx.textBaseline = 'top'
    ctx.fillStyle = '#000'

    const innerW = w - 8
    let size = Math.max(baseSize, minSize) + 7
    ctx.font = `${size}px Arial, Tahoma, sans-serif`

    let lines = wrapText(ctx, text, innerW)
    let lineHeight = size * lineHeightRatio

    while ((lines.length * lineHeight > h) && size > minSize) {
        size -= 1
        ctx.font = `${size}px Arial, Tahoma, sans-serif`
        lines = wrapText(ctx, text, innerW)
        lineHeight = size * lineHeightRatio
    }

    const startY = y + Math.max((h - (lines.length * lineHeight)) / 2, 2)
    lines.forEach((ln, i) => ctx.fillText(ln, x + w - 6, startY + i * lineHeight, innerW))
    ctx.restore()
}

function drawChoice(ctx, value, options, x, y, w, h) {
    const idx = options.indexOf(value)
    if (idx === -1) return

    const cellW = w / options.length
    const cx = x + cellW * idx + cellW / 2
    const cy = y + h / 2
    const r = Math.max(Math.min(cellW, h) / 2 - 4, 6)

    ctx.save()
    ctx.strokeStyle = '#1565c0'
    ctx.lineWidth = 3
    ctx.beginPath()
    ctx.arc(cx, cy, r, 0, Math.PI * 2)
    ctx.stroke()
    ctx.restore()
}

function drawImageField(value, x, y, w, h, ctx) {
    return new Promise((resolve) => {
        let src = null
        let isObjectUrl = false

        // معالجة نوع القيمة لإنشاء الرابط الصحيح
        if (typeof value === 'string') {
            src = `${value}?cb=${new Date().getTime()}`
        } else if (value instanceof File) {
            src = URL.createObjectURL(value)
            isObjectUrl = true
        }

        if (!src) return resolve()

        const img = new Image()
        img.crossOrigin = 'anonymous'
        
        img.onload = () => {
            const scale = Math.min(w / img.width, h / img.height)
            const dw = img.width * scale
            const dh = img.height * scale
            ctx.drawImage(img, x + (w - dw) / 2, y + (h - dh) / 2, dw, dh)
            if (isObjectUrl) URL.revokeObjectURL(src)
            resolve()
        }
        img.onerror = () => {
            if (isObjectUrl) URL.revokeObjectURL(src)
            resolve()
        }
        img.src = src
    })
}

export async function generateDocImage(doc, values, imgEl) {
    const { naturalWidth: width, naturalHeight: height } = imgEl
    const canvas = document.createElement('canvas')
    canvas.width = width
    canvas.height = height
    const ctx = canvas.getContext('2d')

    ctx.drawImage(imgEl, 0, 0, width, height)

    const fields = doc.fields || []
    for (let i = 0; i < fields.length; i++) {
        const { type, x, y, w, h, fontSize } = fields[i]
        const value = values[`field_${i}`]
        
        if (value === undefined || value === null || value === '') continue

        switch (type) {
            case 't': drawWrappedText(ctx, value, x, y, w, h, { baseSize: fontSize ?? 14, minSize: 9 }); break
            case 'ta': drawWrappedText(ctx, value, x, y, w, h, { baseSize: fontSize ?? 12, minSize: 8, lineHeightRatio: 1.3 }); break
            case 'yn': drawChoice(ctx, value, ['yes', 'no'], x, y, w, h); break
            case 'yna': drawChoice(ctx, value, ['yes', 'no', 'na'], x, y, w, h); break
            case 'i': await drawImageField(value, x, y, w, h, ctx); break
        }
    }

    return new Promise((resolve) => canvas.toBlob(resolve, 'image/png'))
}